module.exports = __webpack_public_path__ + "media/images/icons/filled/google-plus-circle-aae05237ad0c6708bf0b487f764faa4f.svg";